import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FeatureSpecsEntities } from 'client/data/models/vehicle-v2';
import { getEngineType } from 'site-modules/shared/utils/features-specs/utils';
import './engine-type-badge.scss';

const BADGE_MAP = {
  'electric (fuel cell)': {
    icons: [], // todo: add icon, not having an icon here may cause CLS related to critical css
    text: 'Fuel Cell Vehicle',
  },
  gas: {
    icons: ['icon-droplet-contrast1'],
    text: 'Gas Engine',
  },
  electric: {
    icons: ['icon-power2'],
    text: 'Electric Vehicle',
  },
  hybrid: {
    icons: ['icon-power2', 'icon-droplet-contrast1'],
    text: 'Hybrid',
  },
  'plug-in hybrid': {
    icons: ['icon-power-cord-thin', 'icon-droplet-contrast1'],
    text: 'Plug-In Hybrid',
  },
  diesel: {
    icons: ['icon-droplet1'],
    text: 'Diesel',
  },
};

export function EngineTypeBadge({ styleFeatures = null, className = null, elementStyle = null }) {
  if (!styleFeatures) {
    return null;
  }

  const engineType = getEngineType(styleFeatures);
  const badge = BADGE_MAP[engineType.toLowerCase()];

  if (!badge) {
    return null;
  }

  return (
    <div
      className={classnames('engine-type-badge medium fw-medium bg-turquoise-100 text-turquoise-10', className)}
      // using inline styles to avoid adding critical css keys
      style={{
        borderRadius: '20px',
        padding: '0 12px 0 8px',
        lineHeight: '22px',
        display: 'inline-flex',
        alignItems: 'center',
        ...elementStyle,
      }}
    >
      {badge.icons.map(icon => (
        <i key={icon} className={icon} aria-hidden />
      ))}
      &nbsp;{badge.text}
    </div>
  );
}

EngineTypeBadge.propTypes = {
  styleFeatures: FeatureSpecsEntities.FeatureStyleEntity,
  className: PropTypes.string,
  elementStyle: PropTypes.objectOf(PropTypes.string),
};
